import BigNumber from 'bignumber.js'

function needValidate(rule) {
  return rule !== undefined
}

export function getErrorMessage(key, value, { balance, min, max, tick }) {
  if (needValidate(balance) && BigNumber(value).gt(balance)) {
    return 'Insufficient balance'
  } else if (needValidate(min) && BigNumber(value).lt(min)) {
    return `Minimum ${key} is ${min}`
  } else if (needValidate(max) && BigNumber(value).gt(max)) {
    return `Maximum ${key} is ${max}`
  } else if (needValidate(tick) && !BigNumber(value).mod(tick).eq(0)) {
    return `Minimum ${key} tick size is ${tick}`
  }
  return ''
}
